import { postRequestToHost } from 'owa-opx-default-adaptor/lib/default-adaptor/messaging/postRequestToHost';
import type { HostNotification } from 'owa-opx-adaptor-protocol';
import type { HostEvent } from 'owa-opx-adaptor-protocol';

export const enum RequestType {
    GET_RESOURCE_TOKEN = 'GetResourceToken',
    // Contains app health and few other signals
    GET_HAPPY_SIGNALS = 'GetHappySignals',
}

export const enum ResponseType {
    UPDATE_RESOURCE_TOKEN = 'UpdateResourceToken',
    UPDATE_HAPPY_SIGNALS = 'UpdateHappySignals',
}

type TPayload = null | string | number | boolean | Record<string, any>;

interface RequestMessage extends HostNotification {
    notificationType: RequestType;
    asyncContext: TPayload;
}

interface ResponseMessage<TResponsePayload> extends HostEvent {
    eventType: ResponseType;
    asyncResult: TResponsePayload;
}

/**
 * Fetches data from the host-app (ex. Outlook Lite).
 * @param requestType Message name to send to host
 * @param requestPayload Message payload to send to host
 * @param responseType Message name to listen for from host
 * @returns Promise that resolves with the payload from the host
 *
 * CAUTION: Please resort to this method only if the data you need cannot be
 *          part of "UpdateConfig" message sent from host during boot.
 */
export const fetchFromHost = async <TResponsePayload extends TPayload>(
    requestType: RequestType,
    requestPayload: TPayload,
    responseType: ResponseType
): Promise<TResponsePayload> =>
    postRequestToHost<RequestMessage, ResponseMessage<TResponsePayload>>(
        requestType,
        requestPayload,
        responseType
    );
